import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../features/auth/AuthContext';
import { PLATFORM_NAME } from '../../config/brand';
import '../../styles/Navbar.css';

const Navbar = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (
    location.pathname === '/' ||
    location.pathname === '/login' ||
    location.pathname === '/register' ||
    location.pathname === '/forgot-password' ||
    location.pathname === '/reset-password' ||
    location.pathname === '/verify-email' ||
    location.pathname.startsWith('/admin')
  ) {
    return null;
  }

  const displayName = user?.name || user?.full_name || 'Student';
  const displayInitial = displayName.charAt(0).toUpperCase();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/dashboard" className="navbar-brand">
          <img src="/newlogo.png" alt={PLATFORM_NAME} style={{ height: '60px', width: 'auto', maxWidth: '240px', objectFit: 'contain' }} />
        </Link>

        {/* Nav links removed — logo returns to dashboard; this product is assessments-only
        {isAuthenticated && (
          <div className="navbar-links">
            <Link to="/dashboard" className="navbar-link">Dashboard</Link>
            <Link to="/problems" className="navbar-link">Problems</Link>
            <Link to="/wallet" className="navbar-link">Credits</Link>
          </div>
        )}
        */}

        <div className="navbar-actions">
          {isAuthenticated ? (
            <div className="user-info">
              <div className="user-avatar">
                {displayInitial}
              </div>
              <div className="user-details">
                <span className="user-name">{displayName}</span>
                <span className="user-module-badge" data-module="learning">
                  Student
                </span>
              </div>
              <div className="user-info-divider" />
              <button onClick={handleLogout} className="user-logout-btn" title="Logout">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" fill="currentColor"/>
                </svg>
              </button>
            </div>
          ) : (
            <Link to="/login" className="nav-link">Sign In</Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
